export default __webpack_public_path__ + "static/media/SamanthaWingert.a9693aa4.jpg";